import React from 'react'
import classNames from './index.scss'
import '@yaireo/tagify/dist/tagify.css'
import config from 'config'
import Button from 'material-ui/FlatButton'
import WebAppIframe from '../../../components/WebAppIframe'

class SocialMediaRewardDefinitionIframe extends React.Component {
  render() {
    return (
      <div style={{ width: '100%', margin: '0 auto', backgroundColor: 'white' }}>
        <WebAppIframe src={`${config.casaWebAppUrl}/social-media`} id="iframe" className={`${classNames.iframe}`} />
      </div>
    )
  }
}

export default SocialMediaRewardDefinitionIframe




// WEBPACK FOOTER //
// ./src/routes/SocialMediaRewardList/containers/index.js